import * as React from "react";
import {createRoot, Root} from 'react-dom/client';
import {WelcomeAssistant} from "./components/WelcomeAssistant/WelcomeAssistant";
import "./style.css";
import {EmailConfirmation} from "./components/EmailConfirmation/EmailConfirmation";
import {InvestAssistant} from "./components/InvestAssistant/InvestAssistant";

(window as any).react = {

    welcome_assistant: function (target: any, config: any) {
        if (target) {
            return createRoot(target).render(
                <WelcomeAssistant config={config} />
            );
        }
    },

    invest_assistant: function (target: any, config: any) {
        if (target) {
            return createRoot(target).render(
                <InvestAssistant config={config} />
            );
        }
    },

    email_confirmation: function (target: any, config: any) {
        if (target) {
            return createRoot(target).render(
                <EmailConfirmation config={config} />
            );
        }
    },

}
